export default "__VITE_ASSET__9f58869c__$_?nuxt_component=async&nuxt_component_name=SvgoMarkerPin04__"